module.exports = __webpack_public_path__ + "static/img/gb-sct.9506ab93.svg";